import React from "react";
import { useNavigate } from "react-router-dom";
import unauthorized from "../../Assets/Images/unauthorized-image.png";
import {
  Button,
} from "@mui/material"
import { getRole } from "../../Components/Helpers/Utilities/Common";

const Unauthorized = () => {
  const navigateTo = useNavigate();

  return (
    <div className="h-screen w-screen flex flex-col justify-center items-center text-center px-4">
      <img
        src={unauthorized}
        alt="Unauthorized Access"
        className="unauthorized-logo"
      />
      <div className="flex flex-col items-center">
        <p className="font-bold text-2xl uppercase">
          You do not have permission to view this page
        </p>
        <Button
          className="login-btn"
          size="medium"
          variant="contained"
          onClick={() => {
            navigateTo("/dashboard");
          }}
        >
          Back to Dashboard
        </Button>
        {/* {getRole() !== "laboratory" ? (
          <>
            <Button
              className="login-btn"
              size="medium"
              variant="contained"
              onClick={() => {
                navigateTo("/dashboard");
              }}
            >
              Back to Dashboard
            </Button>
          </>
        ) : (
          <>
            <Button
              className="login-btn"
              size="medium"
              variant="contained"
              onClick={() => {
                navigateTo("/patients");
              }}
            >
              Back to Patient Manager
            </Button>
          </>
        )} */}
      </div>
    </div>
  );
};

export default Unauthorized;
